export class FilterBase{
  descripcion!:string
}
